import { SETTINGS_FIELD } from "../../MasjidTypes";

export const UPDATE_SETTING = "UPDATE_SETTING";

export const updateSetting = (
  field: typeof SETTINGS_FIELD[keyof typeof SETTINGS_FIELD],
  value: any
) => ({
  type: UPDATE_SETTING,
  payload: { field, value },
});
